import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_EUROPEAN_UNION_STATE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    relationshipToYou: '',
    nationalIdOrVisa: '',
    id: '',
    purposeOfTrip: '',
    ifOtherPleaseDescribe: '',
    didYouContactAssistanceCompany: 'false',
    assistanceCaseReferenceNumberFileNumber: '',
    didYouHaveOtherMedicalInsurance: 'false',
    insuranceCarriersName: '',
    address: '',
    cityOrTown: '',
    country: '',
    postalCode: '',
    policyId: '',
    areYouACitizenOfTheEuropeanUnion: 'false',
    forEUCitizens: 'false',
    ifYesWasTheEHIC: 'false',
    ifNoPleaseExplain: '',
    // hospital & medical expenses
    lossInformationItemsMedicalExpense: [],
    // medicalProviderName: '',
    // descriptionOfexpense: '',
    // expenseDateForHospital: '',
    // actualCostForHospital: '',
    // currencyForHospital: '',

    accidentStartDate: '',
    accidentFirstTreatment: '',
    nameOfPhysicianFacilityFirstContacted: '',
    addressForHospital: '',
    cityOrTownForHospital: '',
    countryForHospital: '',
    postalCodeForHospital: '',
    emailForHospital: '',
    phoneNumberForHospital: '',
    isTheClaimTheResultOfAniLLness: 'false',
    accidentStartDateForIllness: '',
    symptoms: '',
    detailsForIllness: '',
    isTheClaimTheResultOfAccidentOrInjury: 'false',
    place: '',
    accidentDate: '',
    accidentTime: '',
    detailsForAccident: '',
    wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity: 'false',
    ifOtherPleaseDescribeForHospital: '',
    otherDescriptionPleaseProvide: '',
    alternativeTreatment: '',
    // treating physician
    nameOfPhysicianFacilityFirstContactedForPhysician: '',
    addressForPhysician: '',
    cityOrTownForPhysician: '',
    countryForPhysician: '',
    postalCodeForPhysician: '',
    phoneNumberForPhysician: '',
    // provide
    facilityName: '',
    addressForProvide: '',
    cityOrTownForProvide: '',
    countryForProvide: '',
    postalCodeForProvide: '',
    phoneNumberForProvide: '',
    admitDate: '',
    timeOfAdmission: '',
    dischargeDate: '',
    timeOfDischarge: '',
    expensesClaimed: '',
    currencyForProvide: '',
    // injury
    didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness: 'false',
    wereYouTravelingToReceiveMedicalTreatment: 'false',
    ifYesWhenDidYouLearnOfTheAlternativeTreatment: '',
    whoRecommendedTheTreatment: '',
    areYouPregnant: 'false',
    ifYesNumberOfWeeks: '',
    changeTo: 'false',
    ifYesNameOfPhysicianCurrentlyTreatingThis: '',
    prescriptionMedicinesNotInjury: [],
    prescriptionMedicinesForInjury: [],
  },
  errors: [],
});

const initialEuropeanUnionState = {
  form: {
    areYouACitizenOfTheEuropeanUnion: 'false',
    forEUCitizens: 'false',
    ifYesWasTheEHIC: 'false',
    ifNoPleaseExplain: '',
  },
};

function medicalExpenseCFStepReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_EUROPEAN_UNION_STATE:
      return state.mergeDeep(initialEuropeanUnionState);
    // case RESET_TRAVEL_DELAY_STATE:
    //   return state
    //       .setIn(['form', 'descriptionOfItemsForDamaged'], [])
    //       .mergeDeep(initialForBaggageDelayState);
    default:
      return state;
  }
}

export default medicalExpenseCFStepReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.CFTripCan.MedicalExpense/reducer.js